import { render, staticRenderFns } from "./merchantForm.vue?vue&type=template&id=60cbd193&scoped=true&"
import script from "./merchantForm.vue?vue&type=script&lang=ts&"
export * from "./merchantForm.vue?vue&type=script&lang=ts&"
import style0 from "./merchantForm.vue?vue&type=style&index=0&id=60cbd193&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60cbd193",
  null
  
)

export default component.exports